import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 32,
			// height: 32,
		},
	},
}));

function CloudserviceIcon(props) {
	return (
		<svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fillRule="evenodd" clipRule="evenodd" d="M19 25H10H9.48409H5.5C3.01472 25 1 22.9853 1 20.5C1 18.1739 2.76487 16.2601 5.02859 16.0244C5.41325 10.9763 9.63116 7 14.7778 7C18.8555 7 22.3502 9.49614 23.8173 13.0438C24.0459 13.0149 24.279 13 24.5155 13C27.5445 13 30 15.4555 30 18.4845V19C30 22.3137 27.3137 25 24 25H20.0715H19Z" fill={props.fill} />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<CloudserviceIcon fill={props.fill} />
		</div>
	);
}